<template>
  <div class="icon-phone">
    <div class="icon-phone__title">
      <slot />
    </div>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="29"
      viewBox="0 0 28 29"
    >
      <!-- eslint-disable max-len -->

      <path
        class="icon-phone__shape"
        fill="#FFF"
        fill-rule="nonzero"
        d="M14.904 27.054a8.79 8.79 0 0 0 4.426 1.196 8.726 8.726 0 0 0 6.21-2.572 8.344 8.344 0 0 0 2.46-5.94v-1.471l-8.507-3.19-2.313 2.313a28.525 28.525 0 0 1-6.32-6.32l2.313-2.313L9.983.25H8.511a8.344 8.344 0 0 0-5.939 2.46A8.726 8.726 0 0 0 0 8.92c0 1.553.414 3.084 1.196 4.425a38.163 38.163 0 0 0 13.708 13.709zM4.621 4.758A5.46 5.46 0 0 1 7.985 3.17l1.821 4.857-2.69 2.69.658.988a31.464 31.464 0 0 0 8.77 8.77l.988.659 2.69-2.691 4.857 1.821a5.46 5.46 0 0 1-1.587 3.364 5.85 5.85 0 0 1-4.162 1.724 5.892 5.892 0 0 1-2.966-.801A35.255 35.255 0 0 1 3.698 11.886a5.892 5.892 0 0 1-.801-2.966c0-1.572.612-3.05 1.724-4.162z"
      />
      <!-- eslint-enable max-len -->
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconPhone'
};
</script>

<style lang="scss" src="@/assets/icons/icon-phone-view.scss"></style>



// WEBPACK FOOTER //
// icon-phone-view.vue